import { useIsFeatureEnabled } from './useIsFeatureEnabled';
import { useIsScheduleV2RolloutEnabled } from './useIsScheduleV2RolloutEnabled';

// The rollout flag decides who is in the cohort; each feature flag is only a kill-switch.
// Both are bucketed on the same user id, so the three schedule v2 features reach the same users.
export function useIsScheduleV2FeatureEnabled(flagKey, attributes) {
  const isInRollout = useIsScheduleV2RolloutEnabled();
  const isFeatureEnabled = useIsFeatureEnabled(flagKey, attributes);

  if (isInRollout === null || isFeatureEnabled === null) return null;

  return isInRollout && isFeatureEnabled;
}
